import { generateSectionParagraphs } from "../utils/WordExportUtils";
import {
  blueColour,
  defaultFontBold,
  defaultFontItalic,
  defaultFontNormal,
} from "../utils/styling";

export const getCapitalisedRdeParagraphs = (data) => {
  const { groupName, groupHasClaim } = data;

  const paragraphs = [
    {
      condition: true,
      segments: [
        {
          text: "Capitalised Research and Development expenditure:",
          font: defaultFontBold,
          break: 1,
        },
        {
          text: "Certain “relevant” Intangible Fixed Asset debits, including those in relation to amortisation, impairments and losses on sale are excluded from Tax-EBITDA (as tax amortisation). However, expenditure that meets the tax definition of “research and development” in s1138 CTA 2010",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "2",
          superScript: true,
          font: defaultFontNormal,
        },
        {
          text: " is excluded from the Intangible Fixed Asset regime in Part 8, CTA 2009 and therefore is not adjusted in arriving at Tax-EBITDA.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      condition: true,
      segments: [
        {
          text: "Where the capitalised research and development expenditure is revenue in nature, a full deduction is available under s1308 CTA 2009. However, no adjustment is available for Tax-EBITDA regardless of whether a deduction is claimed under s1308 CTA 2009.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      condition: true,
      segments: [
        {
          text: "Application to the ",
          font: defaultFontItalic,
          break: 1,
        },
        {
          text: groupName,
          font: defaultFontItalic,
        },
        {
          text: " group",
          font: defaultFontItalic,
        },
      ],
    },
    {
      condition: true,
      segments: [
        {
          text: "[s1308 claims: ",
          font: defaultFontBold,
          color: blueColour,
        },
        {
          text: "Amounts that qualify for research and development expenditure are excluded from tax under Part 8 CTA 2009 (Intangible Fixed Assets) by s814 CTA 2009 to the extent specified, which includes amortisation debits under Chapter 3. As such, these amounts should not be added back for CIR purposes. A group should generally claim a full deduction for this expenditure in the period incurred under s1308. However, even If the group has not applied s1308 in respect of revenue research and development expenditure, but is claiming a deduction in line with amortisation in the accounts, it will still be necessary to ensure that these amortisation deductions are not added back in calculating Tax-EBITDA. The following paragraphs can be used to highlight this.]",
          font: defaultFontNormal,
          color: blueColour,
          break: 1,
        },
      ],
    },
    {
      condition: groupHasClaim,
      segments: [
        {
          text: "The group has taken a deduction for revenue R&D costs under s1308 CTA 2009. No adjustment has been made to Tax-EBITDA in respect of these costs. We assume that you are comfortable that all revenue expenditure on research and development for which a s1308 deduction applies has been identified, such that no further adjustments are required.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      condition: !groupHasClaim,
      segments: [
        {
          text: "Amounts that qualify for research and development expenditure (as defined for tax purposes) are excluded from tax under s814 CTA 2009 (Intangible Fixed Assets) to the extent specified, which includes amortisation debits under Chapter 3. As such, these amounts should not be added back for CIR purposes.",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "We are not aware of any revenue expenditure on research and development undertaken by UK group companies. Please let us know if you think that a UK group company has incurred any such costs.",
          font: defaultFontNormal,
          break: 2,
        },
      ],
    },
  ];

  return [...generateSectionParagraphs(paragraphs)];
};
